module.exports = __webpack_public_path__ + "static/media/new-loader.aacd8536.png";